// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
let default_addedToCartText = "Added to Cart!";
let default_add_all_to_cart_text = "Add All to Cart";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";
let tangent_client_domain_currency;

const tangent_skin_type_tagging = document.querySelector("#skin-type-taging");

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basics:"Basics",
  section_essentials:"Essentials",
  section_works:"Works",
  section_collection_products:"Program Kits",
  section_routine_content:"Personalized Routine"
}
const productCategoryTitle = {
    0:{
      title:"Cleanser",
      description:"Remove dirt, oil, and makeup. Preps skin for active ingredients. Use morning and night on damp skin, then rinse."
    },
    1:{
      title:"Serum",
      description:"Deliver concentrated actives deep into skin. Apply after cleansing, before moisturiser. Targets concerns like acne, dullness, or wrinkles."
    },
    2:{
      title:"Moisturizer",
      description:"Hydrate and seal in treatment layers. Supports skin barrier. Apply after serum, morning and evening for soft, balanced skin."
    },
    3:{
      title:"Mask & Peel",
      description:"Boost skin weekly with exfoliation or detox. Apply after cleansing, leave for 10–20 minutes, then rinse. Follow with serum."
    },
    4:{
      title:"Day/Night Cream",
      description:"Day creams protect; night creams repair. Apply after serum or moisturiser depending on texture. Supports skin throughout its daily cycle."
    },
    5:{
      title:"Eye Cream",
      description:"Targets puffiness, dark circles, and fine lines. Dab gently under eyes with ring finger—morning and night for best results."
    } 
};

const skinTagMap = {
  normal: "NORMAL",
  dry: "DRY",
  oily: "OILY",
  combination: "COMBINATION",
  sensitive: "SENSITIVE",
  concern_rosacea:"ROSACEA",
  concern_marks:"ACNE MARKS",
  concern_dark_circles:"DARK CIRCLES",
  concern_uneven_skintone: "UNEVEN SKINTONE",
  concern_dullness: "DULLNESS",
  concern_dryness: "DRYNESS",
  concern_darkspots: "DARK SPOTS",
  concern_aging: "FINE LINE/ WRINKLES",
  concern_acne: "ACNE",
  concern_enlarged_pores:"ENLARGED PORES"
};

// Add default image url here
const tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

// Message for each conditions
const condition_text_mapping = {
  dark_circles:"Prone to dark circles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>.",
  wrinkles:"Prone to wrinkles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
  rosacea:"Prone to rosacea here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
  texture:"Prone to texture here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
  darkspots:"Prone to darkspots here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
  acne:"Prone to acne here! Try our <a target='_blank' href='#'><u>Product Name</u></a>"
}

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    // API call for facemapping
    if(response["selfie_id"]!=null){
      setSelfieId(response["selfie_id"]);
      getSelfieMapping(response["selfie_id"]);
      enableSelfieDependedStaticElements();
    }

    setSelfieSkinTagging(response.tags);

    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      loadElementsOnResponseData();    
      enableButtonListener();    
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
  
    setTipsCard(response.text_sections);

    if (response.description == '') {
      setElementDisplay("tangent-general-text", "block");
    }

}

function setTipsCard(text_sections){
  document.querySelectorAll(".section_tips_card").forEach((el, index) => {
    el.innerHTML = text_sections["section_additional_content"].join(' ');
  });
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  let routineList = [];
  const routineContainer = document.getElementById("routine-products-container");
  let routine_html = "";
  Object.keys(sections).forEach(section => {
    console.log("section loading",section);
    const product_ids = sections[section];
    // Get the product section grid element once per section
    let product_section_grid = document.getElementById(section + "_product_grid");
    
    // Create a variable to accumulate the HTML
    let section_html = "";
    let count = 1;
    for (let id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        if (String(products[p].id) === id) {
          let product = products[p];
          
          let variant = getSelectedVariant(product, selected_variants);

          // Update the selected product map
          tangent_selected_product_map[product.id] = variant.id;

          // Generate the product HTML
          let product_html = getProductHTML(product, p, variant, section, sections);

          if(!routineList.includes(product.id) && p<6){
            let temp_routine = getRoutineHTML(product, p, variant, section, sections);
            routine_html += temp_routine;
            routineList.push(product.id);
          }
          // Accumulate the HTML
          section_html += product_html;
        
        }
      }
      if(count==product_ids.length){
        const tips_card = `<div id="${section}_tips_card" class="section_tips_card"></div>`;
        section_html += tips_card;
      }
      count++;
    }

    // Append all the HTML to the section's product grid in one go
    product_section_grid.insertAdjacentHTML('beforeend', section_html);
  });
  routineContainer.insertAdjacentHTML('beforeend', routine_html);
}

const getSelectedVariant = (product, selected_variant_map) => {
  const variantIds = selected_variant_map[product.id] || [];

  if (variantIds.length > 0) {
    const selectedId = variantIds[0];
    const foundEdge = product.variants.edges.find(
      edge => extractVariantId(edge.node.id) == selectedId
    );
    if (foundEdge) {
      return foundEdge.node;
    }
  }
  return product.variants.edges[0]?.node || null;
};

// TAGS TO SHOW UNDER SELFIE
const setSelfieSkinTagging = (tangent_quiz_tags) => {
  const tag = tangent_quiz_tags
    .filter(tag => skinTagMap[tag])
    .map(tag => `<h2>${skinTagMap[tag]}</h2>`)
    .join(' <span class="tag-dot-icon">&#9679;</span> ');

  tangent_skin_type_tagging.innerHTML = tag;
};

function renderCategory(index) {
  if (productCategoryTitle.hasOwnProperty(index)) {
    return `<p class="tangent-product-category-title">${productCategoryTitle[index].title}</p>`;
  }
  return ""; 
}

function renderRoutineCategory(index) {
  if (productCategoryTitle.hasOwnProperty(index)) {
    return `<p class="tangent-product-category-title">STEP ${index+1} : ${productCategoryTitle[index].title}</p>`;
  }
  return ""; 
}

function renderRoutineInfo(index) {
  if (productCategoryTitle.hasOwnProperty(index)) {
    return `${productCategoryTitle[index].description}`;
  }
  return ""; 
}

function extractVariantId(gid) {
  return gid.split("/").pop(); 
}

function getVariantImageUrl(product, variant) {
  return variant.images?.nodes?.[0]?.url 
      ?? product.images?.nodes?.[0]?.url 
      ?? 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function getVariantId(variant) {
  return extractVariantId(variant.id);
}

function getVariantProductUrl(product, variantId) {
  return `${product.onlineStoreUrl}?variant=${variantId}`;
}

function renderProductPrice(index, variant) {
  return `
    <p id="price_tangent_product_${index}" class="tangent_product_price_text">
      ${tangent_client_domain_currency}${Number(variant.price).toFixed(2)}
    </p>
  `;
}

function renderAddToCartButton(product, variant, section, sections, index, variantId) {
  let defaultText = "Add To Cart";
  let classList = "";
  let disabledAttr = "";

  if (isProductActive(product, variant)) {
    updateSectionAllToCartLink(section, product, sections, variantId);
  } else {
    defaultText = out_of_stock_text;
    classList = "disable-btn-wrapper";
    disabledAttr = "disabled";
  }

  return `
    <button 
      class="tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${classList}" 
      id="${variantId}" 
      ${disabledAttr}
    >
      ${defaultText}
    </button>
  `;
}

function renderProductInfotext(product, section) {
  const infoText = product?.product_intro?.value;
  if (infoText) {
    return `
    <div class="info-section">
      <input type="checkbox" id="${section}-info-toggle-${product.id}" class="toggle-info">
      <label for="${section}-info-toggle-${product.id}" class="info-button"></label>
      <div class="info-text">
        <p class="tangent-info-text">${infoText}</p>
      </div>
    </div>
    `;
  }
  return '';
}

function getRoutineHTML(product, index, variant, section, sections){
  const variantId = getVariantId(variant);
  const variantImageUrl = getVariantImageUrl(product, variant);
  

  return `
    <div class="tangent-product-border-div">
      ${renderRoutineCategory(index)}
      <div class="tangent-product-inner-div">
        <p class="routine-text">${renderRoutineInfo(index)}</p>
        <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent_product_image" alt="${product.title}">
        ${renderAddToCartButton(product, variant, section, sections, index, variantId)}
      </div>
    </div>
  `;
}

function renderRatingStars(product) {
  if (!product.product_rating) return '';

  // Parse the rating metafield
  let rating = 0;
  try {
    const ratingData = JSON.parse(product.product_rating.value);
    rating = parseFloat(ratingData.value);
  } catch (e) {
    console.error('Invalid rating metafield:', e);
    return '';
  }

  const fullStar = '<span class="jdgm-star jdgm--on"></span>';
  const halfStar = '<span class="jdgm-star jdgm--half"></span>';
  const emptyStar = '<span class="jdgm-star jdgm--off"></span>';

  // Round to nearest half
  const rounded = Math.round(rating * 2) / 2;
  const fullCount = Math.floor(rounded);
  const hasHalf = rounded % 1 === 0.5;
  const emptyCount = 5 - fullCount - (hasHalf ? 1 : 0);

  let html = ``;
  html += `<span class="jdgm-prev-badge__stars" data-score="${rating}" aria-label="${rating} stars">`;

  for (let i = 0; i < fullCount; i++) html += fullStar;
  if (hasHalf) html += halfStar;
  for (let i = 0; i < emptyCount; i++) html += emptyStar;

  html += `</span>`;

  return html;
}

function renderReviewCount(product) {
  if (!product.product_reviews) return '';
  let count = 0;
  try {
    count = parseInt(product.product_reviews.value, 10);
  } catch (e) {
    console.error('Invalid review count metafield:', e);
    return '';
  }
  return `&nbsp;${count} review${count !== 1 ? 's' : ''}`;
}

function renderRatingHTML(product) {
  // Render stars and review count separately
  const starsHTML = renderRatingStars(product);
  const reviewsHTML = renderReviewCount(product);

  return `<div id="custom-rating-section">${starsHTML} ${reviewsHTML}</div>`;
}

function getProductHTML(product, index, variant, section, sections) {
  const variantId = getVariantId(variant);
  const variantImageUrl = getVariantImageUrl(product, variant);
  const variantProductUrl = getVariantProductUrl(product, variantId);
  return `
    <div class="tangent-product-border-div">
      ${renderCategory(index)}
      <div class="tangent-product-inner-div">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
          <div style="padding:2rem;background-color:#F6F6F6">
            <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent_product_image" alt="${product.title}">
          </div>
        </a>
        ${renderAddToCartButton(product, variant, section, sections, index, variantId)}
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
          <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
        </a>
        <div id="${section}_variant_${index}"></div>
        ${renderRatingHTML(product)}
        ${renderProductPrice(index, variant)}
        ${renderProductInfotext(product, section)}
        ${renderDiscountSection(product)}
      </div>
    </div>
  `;
}

const renderDiscountSection = (product) => {
  let discount_value = 5;
  if(product.rise_ai_discount){
    discount_value = product.rise_ai_discount.value;
  }
  return `<div class="cashback-btn-wrp">
  <div class="cashback-btn" data-discount="${discount_value}%">
    <span class="doller-icn">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.64974 49.803C10.2753 57.2094 19.2307 62 29.3172 62C46.3465 62 60.1514 48.3447 60.1514 31.5C60.1514 14.6553 46.3465 1 29.3172 1C20.1401 1 11.8994 4.96568 6.25096 11.2591C5.38575 12.2231 4.58136 13.2417 3.84375 14.3091" stroke="black" stroke-width="2" stroke-linecap="round"></path>
        <path d="M6.25096 11.2591L6.99518 11.927L6.99518 11.927L6.25096 11.2591ZM2.86003 14.4888C2.95928 15.0321 3.48017 15.3921 4.02346 15.2928L12.8769 13.6754C13.4202 13.5761 13.7802 13.0552 13.6809 12.512C13.5817 11.9687 13.0608 11.6087 12.5175 11.7079L4.64775 13.1457L3.21004 5.27591C3.11079 4.73261 2.5899 4.37265 2.04661 4.4719C1.50332 4.57116 1.14335 5.09204 1.24261 5.63534L2.86003 14.4888ZM60.1514 31.5H59.1514C59.1514 47.7822 45.8045 61 29.3172 61V62V63C46.8884 63 61.1514 48.9072 61.1514 31.5H60.1514ZM29.3172 1V2C45.8045 2 59.1514 15.2178 59.1514 31.5H60.1514H61.1514C61.1514 14.0928 46.8884 0 29.3172 0V1ZM6.25096 11.2591L6.99518 11.927C12.4606 5.83751 20.4339 2 29.3172 2V1V0C19.8463 0 11.3381 4.09385 5.50675 10.5912L6.25096 11.2591ZM3.84375 14.3091L4.66642 14.8776C5.3799 13.8452 6.15806 12.8597 6.99518 11.927L6.25096 11.2591L5.50675 10.5912C4.61344 11.5865 3.78283 12.6383 3.02108 13.7406L3.84375 14.3091ZM29.3172 62V61C23.4395 61 17.9622 59.3204 13.3455 56.4213L12.8137 57.2681L12.2819 58.115C17.2089 61.209 23.0535 63 29.3172 63V62Z" fill="black"></path>
        <path d="M25.8304 25.7163C25.857 27.4995 26.9216 29.0698 29.0242 30.4271V22.4027C28.9976 22.4027 28.971 22.4027 28.9444 22.4027C26.8684 22.6955 25.8304 23.8 25.8304 25.7163ZM33.6552 40.6473C33.5754 38.9705 32.4176 37.3869 30.182 35.8965V44.5996C32.4442 44.2003 33.602 42.8829 33.6552 40.6473ZM30.182 49.1906H29.0242V45.9569C26.2563 45.9303 24.0073 45.5045 22.2773 44.6794C20.4409 43.7479 19.5227 42.5369 19.5227 41.0465C19.5227 40.7537 19.5759 40.4609 19.6824 40.1682C20.0816 39.1302 20.9466 38.6112 22.2773 38.6112C23.1024 38.6112 23.7411 38.7842 24.1936 39.1302C24.6993 39.5028 25.0985 40.3412 25.3913 41.6453C25.5243 42.1776 25.6308 42.5768 25.7107 42.843C26.1631 44.0939 27.1479 44.7193 28.6649 44.7193H29.0242V35.2577C28.8645 35.1779 28.6782 35.0847 28.4653 34.9783C25.7506 33.6209 24.2468 32.8624 23.9541 32.7027C21.5055 31.2389 20.2812 29.5222 20.2812 27.5527C20.2812 26.1421 20.7337 24.9178 21.6386 23.8798C23.2088 22.1499 25.6707 21.2583 29.0242 21.205V17.6519H30.182V21.205C31.8321 21.2849 33.3225 21.5776 34.6533 22.0833C36.8357 22.9616 37.9269 24.1327 37.9269 25.5965C37.9269 25.8094 37.9136 26.009 37.887 26.1953C37.6475 27.4196 36.8889 28.0318 35.6114 28.0318C34.8662 28.0318 34.254 27.8721 33.775 27.5527C33.2693 27.1801 32.91 26.355 32.6971 25.0775C32.6172 24.5984 32.5374 24.2524 32.4575 24.0395C32.1382 22.9217 31.3796 22.3628 30.182 22.3628V31.1058C30.4215 31.2389 30.6876 31.3719 30.9804 31.505C33.5887 32.8358 35.0392 33.581 35.332 33.7407C37.7007 35.2045 38.885 36.9212 38.885 38.8907C38.885 40.3545 38.4459 41.632 37.5676 42.7232C36.0506 44.6395 33.5887 45.7041 30.182 45.917V49.1906Z" fill="black"></path>
      </svg>
    </span>
    <span class="text">Earn ${discount_value}% Cashback</span>
    <span class="info-icn">
      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.92676" cy="7.66113" r="6.76562" stroke="#615A5A"></circle>
        <path d="M8.83759 5.11542C8.60597 5.11542 8.40743 5.04097 8.24199 4.89207C8.07654 4.74317 7.99382 4.5405 7.99382 4.28406C7.99382 4.01107 8.09309 3.78359 8.29162 3.6016C8.49016 3.41961 8.71351 3.32861 8.96168 3.32861C9.20157 3.32861 9.4001 3.4072 9.55728 3.56437C9.71445 3.71327 9.79304 3.90767 9.79304 4.14757C9.79304 4.41228 9.69377 4.63976 9.49524 4.83003C9.30497 5.02029 9.08576 5.11542 8.83759 5.11542ZM7.69602 12.1634C7.44785 12.1634 7.24105 12.1013 7.0756 11.9772C6.91843 11.8449 6.83984 11.6546 6.83984 11.4065C6.83984 11.2658 6.85639 11.0963 6.88948 10.8977C6.92257 10.6992 6.95979 10.4965 7.00115 10.2897L7.58435 7.48542C7.6588 7.13798 7.53058 6.90222 7.19969 6.77814L7.02597 6.70369L7.05079 6.48034L9.28429 5.8351L9.40838 5.95919L8.46534 10.389C8.43225 10.5296 8.40743 10.6537 8.39089 10.7612C8.37435 10.8605 8.36607 10.9556 8.36607 11.0466C8.36607 11.2286 8.4488 11.3196 8.61424 11.3196C8.81277 11.3196 9.07335 11.1624 9.39597 10.8481L9.55728 11.0094C9.35047 11.3155 9.0899 11.5843 8.77555 11.8159C8.46948 12.0476 8.10963 12.1634 7.69602 12.1634Z" fill="#615A5A"></path>
      </svg>
    </span>
  </div>
</div>`;
}

const isProductActive = (product, variant) => {
  return product?.status?.toLowerCase() === "active" && variant?.availableForSale;
};

const setTabOpen = (tags) => {
    // Show the tab wrapper
    setElementDisplay("tab-wrapper", "block");

    // Get all tabs and tab links
    const tabContents = document.querySelectorAll(".tabcontent");
    const tabLinks = document.querySelectorAll(".tablinks");

    // Hide all tabs and remove 'active' class from all links
    tabContents.forEach(tab => (tab.style.display = "none"));
    tabLinks.forEach(link => link.classList.remove("active"));

    // Determine which tab to show
    let activeIndex = 2; // Default to the third tab
    if (tags.includes("routine_5mins")) {
        activeIndex = 0;
    } else if (tags.includes("routine_10mins")) {
        activeIndex = 1;
    }
    // Set the selected tab active
    tabContents[activeIndex].style.display = "block";
    tabLinks[activeIndex].classList.add("active");
};

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section, product, product_sections, variant_id) {
    // Initialize the section map if it doesn't exist
    if (!sections_add_to_cart_map[section]) {
        sections_add_to_cart_map[section] = {
            count: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };
    }

    // Retrieve the section map entry
    let section_map = sections_add_to_cart_map[section];

    // Add the variant if it's not already in the list
    if (!section_map.list.includes(variant_id)) {
        section_map.list.push(variant_id);
        section_map.count++;
        section_map.cart_link += `&id[]=${variant_id}`;

        // Show the "Add All to Cart" button if there's more than 1 product
        if (section_map.count > 1) {
            let addAllButton = document.getElementById(`${section}`);
            if (addAllButton) {
                addAllButton.style.display = "block";
            }
        }
    }

}

const setElementDisplay = (element_id, displayType) => {
  const element = document.getElementById(element_id);
  if (!element) return;
  
  element.style.display = displayType;
}

function createFormDataFromIds(idArray, sectionName) {
  const addProperties = sectionName === "section_essentials" || sectionName === "section_works";

  return {
    items: idArray.map(id => {
      const item = { id, quantity: 1 };
      if (addProperties) {
        item.properties = {
          _type: "tangent_"+sectionName,
          _variantIds: idArray
        };
      }
      return item;
    })
  };
}


function addToCart(element){ 
  const formData = createFormDataFromIds([element.id], element.id);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element.id);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div>Adding to cart...</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function createSectionContainer(section_name) {
  const section_container = document.createElement("div");
  section_container.id = `${section_name}_container`;

  // Sections that should NOT get the "tabcontent" class
  const excludedSections = [
    "section_additional_content",
    "section_selfie"
  ];

  if (!excludedSections.includes(section_name)) {
    section_container.classList.add("tabcontent");
  }

  return section_container;
}

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add(
        "section_add_all_to_cart",
        `${section_name}_add_all_to_cart`,
        "btn"
    );

    let buttonText = "Add All, Get ";
    switch (section_name) {
      case "section_essentials":
        buttonText += "10% Off!";
        break;
      case "section_works":
        buttonText += "20% Off!";
        break;
      default:
        buttonText =  default_add_all_to_cart_text;
    }

    add_all_to_cart_button.innerHTML = buttonText;

    // Attach click listener
    add_all_to_cart_button.addEventListener("click", () => {
        addAllTocartFunction(add_all_to_cart_button);
    });

    return add_all_to_cart_button;
}


// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      
      createTabButton(section_name);
      
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            if(section_name == "section_routine_content"){
              createTabButton(section_name);
            }
            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else{
              console.log("section ",section_name);
              if(section_name!="section_additional_content"){
                // Add to main container wrapper
                tangent_sections_wrapper_element.appendChild(section_container); 
              }
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      // console.log(response);
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          setElementDisplay("tangent_selfie_image","flex");
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                setElementDisplay("loading-section","none");
                setElementDisplay("canvas_img", "block");
                setElementDisplay("tangent_selfie_image","flex");
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
              setElementDisplay("tangent_selfie_container","none");
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  
  setElementDisplay(element.name+"_container", "flex");
  document.getElementById(element.name+"_tab_button").classList.add("active");
}


function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              if(tangent_facemap_data!=undefined){
                setScores(tangent_facemap_data.scores);
                document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);
              }
             
              setElementDisplay("loading-section", "none");
              setElementDisplay("canvas_img", "block");
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

// Setting scores below the selfie
function setScores(scores){
  var scores_present = false;
  var concern_count = 0;
  Object.keys(scores).forEach(key => {
    const value = scores[key];
    switch(key) {
      case "acne":
          setElementDisplay("Acne_Score_container", "flex");
          document.querySelector("#Acne_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "rosacea":
          setElementDisplay("Rosacea_Score_container", "flex");
          document.querySelector("#Rosacea_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "darkspots":
          setElementDisplay("DarkSpots_Score_container", "flex");
          document.querySelector("#DarkSpots_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "wrinkles":
          setElementDisplay("Wrinkles_Score_container", "flex");
          document.querySelector("#Wrinkles_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "dark_circles":
          setElementDisplay("DarkCircles_Score_container", "flex");
          document.querySelector("#DarkCircles_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      case "texture":
          setElementDisplay("Texture_Score_container", "flex");
          document.querySelector("#Texture_Score").innerHTML=value;
          scores_present= true;
          concern_count=concern_count+1;
        break;
      default:
        break;
        // No Concerns Found
    }
  });

  // Show only if atleast one concern is found
  if(scores_present){
    setElementDisplay("facemap_all_scores_container", "flex");
  }
}


// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function enableSelfieDependedStaticElements(){
  setElementDisplay("tangent_score_description", "block");
  setElementDisplay("skin-health-title-container", "block");
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas(){
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          // getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      
      drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
      drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
      drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
      drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
      drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
      drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc]);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas,condition){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x:event.clientX - rect.left,
    _y:event.clientY - rect.top
  }
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}


// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
  // https://stackoverflow.com/a/29915728/960654
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    
  var x = pt._x,
    y = pt._y

  var inside = false;
  for(var c=0;c<points_list.length;c++){
    var points = points_list[c];
    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
      var xi = points[i][0],
        yi = points[i][1]
      var xj = points[j][0],
        yj = points[j][1]

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
  }
  return inside
}
